import { Typography } from '@kizen/kds/Typography';
import BasicModal from '__components/Modals/presets/BasicModal';
import { useTranslation } from 'react-i18next';

type WarningModalProps = {
  modalProps: any;
  planTitle: string;
  corePlanSelection?: boolean;
};

export const WarningModal = (props: WarningModalProps) => {
  const { modalProps, planTitle, corePlanSelection } = props;
  const { t } = useTranslation();

  return (
    <BasicModal
      {...modalProps}
      heading={
        corePlanSelection
          ? t('Paid Core Plan Required')
          : t('Core Platform Upgrade Required')
      }
      buttonText={t('Continue')}
    >
      <div className="pb-2">
        <Typography>
          {corePlanSelection
            ? t(
                'One or more paid plans requires a paid Kizen core platform plan. To downgrade your core plan, please downgrade existing plans first.'
              )
            : t(
                'The chosen {{planTitle}} plan requires a paid Kizen core platform plan. Please upgrade your core platform and try your selection again.',
                {
                  planTitle: planTitle.toLowerCase(),
                }
              )}
        </Typography>
      </div>
    </BasicModal>
  );
};
